import {Route} from '@angular/router';
import {SeAuthGuardService} from 'se-fe-auth-support';
import {OauthCallbackComponent} from './auth/oauth-callback/oauth-callback.component';
import {orderResolver} from './order-details/order-details.resolver';
import {ordersResolver} from './order-history/resolvers/orders.resolver';
import {provideState} from '@ngrx/store';
import {orderHistoryFeature} from './order-history/state/order-history.reducer';
import {OrderHistoryEffects} from './order-history/state/order-history.effects';
import {orderDetailsFeature} from './order-details/state/order-details.reducer';
import {OrderDetailsEffects} from './order-details/state/order-details.effects';
import {OrderApiService} from './data/order-api.service';
import {provideEffects} from '@ngrx/effects';
import {OrderDetailsNavigationService} from 'app/order-details/order-details-navigation.service';
import {ErrorPageComponent} from 'app/core/components/error-page/error-page.component';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/orders',
    pathMatch: 'full',
  },
  {
    path: 'orders',
    loadComponent: () => import('./order-history/order-history.component').then(m => m.OrderHistoryComponent),
    resolve: {orders: ordersResolver},
    canActivate: [SeAuthGuardService],
    providers: [OrderApiService, provideState(orderHistoryFeature), provideEffects(OrderHistoryEffects)],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'orders/:saleNumber',
    resolve: {order: orderResolver},
    loadComponent: () => import('./order-details/order-details.component').then(m => m.OrderDetailsComponent),
    canActivate: [SeAuthGuardService],
    providers: [
      OrderApiService,
      provideState(orderDetailsFeature),
      provideEffects(OrderDetailsEffects),
      OrderDetailsNavigationService,
    ],
  },
  {
    path: 'oauth/callback',
    component: OauthCallbackComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
];
